<template>
  <div class="modal-content">
    <div
      class="wallpaper-image-wrapper"
      @click="clickWallpaper()"
    >
      <img
        :src="wallpaperThmb"
        height="361"
        width="261"
        class="wallpaper-image"
      >
      <img
        src="@images/icon/ico_finger.png"
        height="111"
        width="130"
        class="icon_finger"
      >
    </div>
    <p class="wallpaper-text">
      {{ $t('wallpaper.text001') }}<br>
      {{ $t('wallpaper.text002') }}
    </p>
    <p class="wallpaper-text" v-html="$t('wallpaper.text003')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import localeModal from '@locales/modal'

export default {
  name: 'modal-get-wallpaper',
  $messages: localeModal,
  computed: {
    ...mapState('modal', ['modal']),
    wallpaperThmb() {
      if (this.$route.params.lang === 'ja-JP') {
        return require(`@images/mypage/ja-JP/wallpapers_s-${this.times}times.png`)
      } else {
        return require(`@images/mypage/en-US/wallpapers_s-${this.times}times.png`)
      }
    },
    times() {
      return this.modal.props.times
    },
    image() {
      return this.modal.props.image
    }
  },
  methods: {
    clickWallpaper() {
      if (!this.image)return
      window.open(this.image)
    }
  }
}
</script>

<style lang="scss" scoped>
.wallpaper-image-wrapper {
  background-image: url(~@images/vote/bg_vote-confirm.png);
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto -40px;
  width: 486px;
  height: 472px;
  position: relative;
  @include tap-event();
}
.wallpaper-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.icon_finger {
  position: absolute;
  bottom: 60px;
  right: 50px;
}
.wallpaper-text {
  font-size: $fs-xlarge;
  text-shadow: $ts-base;
  text-align: center;
  padding: 10px 60px;
}
</style>
